"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
// https://github.com/cure53/DOMPurify
var clean = function clean(dirty /*: string*/) {
  return /*: string*/_dompurify.default.sanitize(dirty, {
    USE_PROFILES: {
      html: true
    }
  });
};
var _default = exports.default = clean;
//# sourceMappingURL=sanitizer.js.map